import styled from 'styled-components'

export const Container = styled.div`
    width: 94%;
    height: 100%;
    display: grid;
    grid-template-rows: repeat(2, 1fr);
    gap: 3px;
    cursor: pointer;
`

export const Content = styled.div`
   display: flex;
   align-items: center;
   justify-content: center;
   flex-direction: column;
   background: var(--colorBackgroundSubCardsDashboard);
   border-radius: 0.25rem;
   position: relative;

   svg{
       cursor: pointer;
   }
`

export const Title = styled.p`
    font-size: 1.2rem;
    color: var(--colorFontsCardsDashboard);
    font-weight: 700;
    margin-bottom: 20px;
    position: absolute;
    top: 10px;
`